/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgForm64(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={64}
      height={64}
      fill='none'
      viewBox='0 0 64 64'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={2}
        d='M50 10H6v52h44V10zM16 24h24M16 36h24M16 48h8'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={2}
        d='M12 2h46v54'
      />
    </svg>
  );
}

export default SvgForm64;
